// extracted by css-extract-rspack-plugin
export default {"card":"bN2vZ","selected":"tqwid","header":"kC3Tm","fields":"xOifz"};